import { type ReactNode } from 'react';

/**
 * Stub provider — the real implementation is pending.
 * This passthrough keeps the app functional in the meantime.
 */
export const ProcessingJobTrackerProvider = ({ children }: { children: ReactNode }) => (
  <>{children}</>
);
